import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, formatError } from "@/lib/api";

export const AppAccessPanel = () => {
  const [emails, setEmails] = useState([]);
  const [email, setEmail] = useState("");

  const load = () => api.get("/admin/app-access").then((r) => setEmails(Array.isArray(r.data) ? r.data : [])).catch(() => {});

  useEffect(() => {
    load();
  }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/app-access", { email });
      setEmail("");
      toast.success("Accesso concesso");
      load();
    } catch (err) {
      toast.error(formatError(err));
    }
  };
  const remove = async (em) => {
    await api.delete(`/admin/app-access/${encodeURIComponent(em)}`).catch(() => {});
    load();
  };

  return (
    <div data-testid="app-access-panel">
      <p className="mb-4 max-w-2xl text-sm text-[#a3b1aa]">
        Chi acquista un prodotto con "Sblocca app NUTRI" ottiene l'accesso in automatico (stessa email Google). Qui puoi concedere l'accesso manualmente.
      </p>
      <form onSubmit={add} className="mb-5 flex max-w-lg gap-2">
        <Input data-testid="app-access-email-input" type="email" required placeholder="email@gmail.com" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11" />
        <button data-testid="app-access-add-btn" className="bg-[#98bfa2] px-5 font-display text-base font-800 uppercase text-[#050807] hover:bg-[#c4dcca]">Concedi</button>
      </form>
      {emails.length === 0 && <p data-testid="app-access-empty" className="text-sm text-[#a3b1aa]">Nessun accesso manuale.</p>}
      <div className="divide-y divide-white/5 border border-[rgba(152,191,162,0.15)]">
        {emails.map((em) => (
          <div key={em} data-testid={`app-access-row-${em}`} className="flex items-center justify-between p-3 text-sm">
            {em}
            <button data-testid={`app-access-remove-${em}`} onClick={() => remove(em)} className="p-1 hover:text-red-400" aria-label="Rimuovi"><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
    </div>
  );
};
